<template lang="html">
  <div />
</template>
<script>
export default {
  mounted() {
    const order_id = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_id')
    if (order_id) {
      this.$router.push({ name: '_resp_order', params: { id: order_id }}).catch(() => {})
    } else {
      this.$router.push({ name: '_payment' }).catch(() => {})
    }
  }
}
</script>
